import config from '../config/config';

class TokenOptionsApi {
  static async getTokenMarketData({
    ids = [],
    category = '',
    order = 'market_cap_desc',
    perPage = 10,
    page = 1,
    sparkline = false,
    vsCurrency = 'usd',
  } = {}) {
    try {
      const params = new URLSearchParams({
        vs_currency: vsCurrency,
        order,
        per_page: perPage,
        page,
        sparkline: sparkline,
      });

      if (ids.length > 0) {
        params.append('ids', ids.join(','));
      }

      if (category) {
        params.append('category', category);
      }

      const response = await fetch(
        `${config.get('coingecko.baseUrl')}/coins/markets?${params}&price_change_percentage=1h%2C24h?order=market_cap_desc`,
        {
          headers: {
            'x-cg-demo-api-key': config.get('coingecko.credentials'),
          },
        }
      );

      if (!response.ok) {
        throw new Error(`CoinGecko API error: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching token market data:', error);
      throw error;
    }
  }

  static async getTokenSearchData({ query = '' } = {}) {
    try {
      if (!query) {
        throw new Error('Search query is required');
      }

      const params = new URLSearchParams({
        query,
      });

      const response = await fetch(`${config.get('coingecko.baseUrl')}/search?${params}`, {
        headers: {
          'x-cg-demo-api-key': config.get('coingecko.credentials'),
        },
      });

      if (!response.ok) {
        throw new Error(`CoinGecko API error: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error searching tokens:', error);
      throw error;
    }
  }

  static async getSupportedVsCurrencies() {
    try {
      const response = await fetch(`${config.get('coingecko.baseUrl')}/simple/supported_vs_currencies`, {
        headers: {
          'x-cg-demo-api-key': config.get('coingecko.credentials'),
        },
      });

      if (!response.ok) {
        throw new Error(`CoinGecko API error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching supported currencies:', error);
      throw error;
    }
  }
}

export default TokenOptionsApi;
